import Axios from "axios";
import { config } from "./config";

export const sendEmailToAdmin = async () => {
    console.log("HEll")
  return await Axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/contact`, {
    ...config(),
  });
};
